import { InputLabel, MenuItem } from '@mui/material';
import { AxiosResponse } from 'axios';
import { memo } from 'react';
import { __PRACTICE_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { ItemVM } from 'shell/view-models/item';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { ReasonMutation } from 'shell/models/reason-mutation';

export interface ReasonMutationVM extends ItemVM {
  element?: ReasonMutation;
}

interface ReasonMutationListProps {
  value?: string;
  onChange: (value: string, item?: ReasonMutationVM) => void;
  error?: boolean;
  id?: string;
  required?: boolean;
  label?: string;
  disabled?: boolean;
}

const ReasonMutationListComponent = ({
  value,
  onChange,
  id,
  error,
  label = 'Motivo',
  required,
  disabled,
}: ReasonMutationListProps): React.ReactElement => {
  const [reasonMutationList] = useHttpFetch<
    HttpResponseList<ReasonMutation>,
    Array<ReasonMutationVM>
  >(`${__PRACTICE_API_URL__}/pratiche/tipo-operazione/tipo-registro/RETTIFIC`, {
    onBootstrap: true,
    options: {
      errorCatching: true,
      method: 'GET',
      loading: true,
    },
    transformer: (response: AxiosResponse<HttpResponseList<ReasonMutation>>) => {
      const { data } = response;
      return data?.payload?.list?.map((item) => ({
        id: `${item.key?.tipoPratica}_${item.key?.tipoOperazione}` || '',
        value: item.descrizioneBreveTipoOperazione || '',
        element: item,
      }));
    },
  });

  const reasonList = (reasonMutationList.data as Array<ReasonMutationVM>) || [];

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} id={`label-select-${id}`} disabled={disabled}>
        {required ? `${label} *` : label}
      </InputLabel>
      <PmiSelect
        error={error}
        labelId={`label-select-${id}`}
        id={id}
        disabled={disabled}
        name={id}
        value={value}
        label={required ? `${label} *` : label}
        onChange={(event) =>
          onChange(
            event?.target.value,
            reasonList.find((item) => item.id === event.target.value)
          )
        }
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {reasonList.map((item: ReasonMutationVM) => (
          <MenuItem key={item.id} value={item.id}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ReasonMutationListComponent.displayName = 'Reason Mutation List Select';

const ReasonMutationList = memo(ReasonMutationListComponent);

export default ReasonMutationList;
